module.exports = __webpack_public_path__ + "static/media/cockfight.931ed97e.png";